import { render } from "./MenuAirport.vue?vue&type=template&id=3ed35c30&scoped=true"
import script from "./MenuAirport.vue?vue&type=script&lang=js"
export * from "./MenuAirport.vue?vue&type=script&lang=js"

import "./MenuAirport.vue?vue&type=style&index=0&id=3ed35c30&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3ed35c30"]])

export default __exports__